import PrimaryFillButton from '@/components_fbl/buttonComponents/PrimaryFillButton';
import CustomImage from '@/components_fbl/globalComponents/CustomImage/CustomImage';
import SubtitleHeading from '@/components_fbl/headingComponents/SubtitleHeading';
import { Box, Typography } from '@mui/material';

function AdvantageCard({ item, ...props }) {
  return (
    <>
      {!item.cta ? (
        <Box
          sx={{
            backgroundColor: `#F0F0F0`,
            padding: theme => theme.spacing(4, 4),
            borderRadius: { xs: 2, md: 3 },
            minHeight: { xs: '120px', sm: '86px', md: '280px' },
            width: { xs: '100%' },
            transitionDuration: '0.3s',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            justifyContent: 'start',
            gap: 2,
          }}
        >
          <CustomImage
            alt={item.title}
            width={{
              xs: '60px',
            }}
            aspectRatio={'1/1'}
            src={item.image}
          />
          <Typography
            variant="body1"
            sx={{
              color: '#212121',
              fontSize: 'clamp(16px,1.8vw, 24px)',
              fontWeight: '600',
            }}
          >
            {item.title}
          </Typography>
          <SubtitleHeading>{item.description}</SubtitleHeading>
        </Box>
      ) : (
        <Box
          sx={{
            backgroundColor: `#993471`,
            padding: theme => theme.spacing(4, 4),
            borderRadius: { xs: 2, md: 3 },
            minHeight: { xs: '120px', sm: '86px', md: '280px' },
            display: 'flex',
            gap: '8px',
            flexDirection: 'column',
            alignItems: 'start',
            justifyContent: 'start',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: '#fff',
              fontSize: 'clamp(16px,1.8vw, 24px)',
              fontWeight: '600',
            }}
          >
            Try RazorSwift Now
          </Typography>
          <PrimaryFillButton
            href={`/login`}
            sx={{
              backgroundColor: 'primaryPalette.white',
              mt: { xs: 0, md: 2 },
              color: '#993471',
              transition: 'all 300ms ease',
              '&:hover': {
                transform: 'translateY(-10px)',
                transation: 'transform 200ms ease',
              },
            }}
          >
            Get A Demo
          </PrimaryFillButton>
        </Box>
      )}
    </>
  );
}

export default AdvantageCard;
